import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeDetalhesStyles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Alert from '@material-ui/lab/Alert';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';


function ModalidadeDetalhes(props) {
  const {
    expandedDetalhes,
    setExpandedDetalhes,
    visitaFiliado,
    indexModalidade,
    armas,
    insumos,
    pacotes
  } = props;

  const classes = useStyles();

  const expandRodada = panel => (event, isExpanded) => {
    setExpandedDetalhes(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <ExpansionPanel
          variant={'outlined'}
          expanded={expandedDetalhes === ('panel1')} onChange={expandRodada('panel1')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>{"Detalhes"}</Typography>
            <Typography className={classes.secondaryHeading}>{'Detalhes da modalidade (arma, pacote, insumo e valores)'}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote} color='primary' name="checkUtilizaPacote" />}
                  label="Utilizar Pacote"
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria} color='primary' name="armaPropria" />}
                  label="Arma própria"
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio} color='primary' name="insumoProprio" />}
                  label="Insumo Próprio"
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ?
                    <Alert severity="info">Utilização de pacote não se aplica a esta visita.</Alert>
                    :
                    <Autocomplete
                      disabled
                      id="pacote"
                      options={pacotes.result}
                      getOptionLabel={option => option.descricao}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Pacote"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe o pacote desejado.'
                        />
                      }
                    />
                }
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria ?
                    <TextField
                      disabled
                      label="CRAF"
                      helperText='Nº CRAF da arma.'
                      variant="outlined"
                      fullWidth
                      margin='dense'
                      type='number'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscal}
                    />
                    :
                    <Autocomplete
                      id="arma-propria"
                      disabled
                      options={armas.result}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].arma}
                      getOptionLabel={option => option.descricao}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Arma"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe a arma desejada.'
                        />
                      }
                    />
                }
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio ?
                    <TextField
                      disabled
                      label="Nº nota fiscal"
                      helperText='Nº nota fiscal insumo.'
                      variant="outlined"
                      fullWidth
                      margin='dense'
                      type='number'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscalInsumo}
                    />
                    :
                    <Autocomplete
                      disabled
                      id="combo-box-demo"
                      options={insumos.result}
                      getOptionLabel={option => option.descricao}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumo}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Insumo"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe o insumo desejado.'
                        />
                      }
                    />
                }
              </Grid>
              {
                !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote &&
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  {
                    <CurrencyTextField
                      disabled
                      label="Valor unitário"
                      helperText='Valor unitário de cada disparo.'
                      variant="outlined"
                      currencySymbol="R$"
                      minimumValue="0"
                      outputFormat="number"
                      decimalCharacter=","
                      digitGroupSeparator='.'
                      fullWidth
                      disabled
                      margin='dense'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo}
                    />
                  }
                </Grid>
              }

              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <TextField
                  disabled
                  label="Quantidade"
                  helperText='Quantidade de disparos fornecidos.'
                  variant="outlined"
                  fullWidth
                  margin='dense'
                  type='number'
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade}
                />
              </Grid>
              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <CurrencyTextField
                  disabled
                  label="Desconto"
                  helperText='Informe um valor em percentual, caso queira aplicar algum desconto.'
                  variant="outlined"
                  currencySymbol="%"
                  minimumValue="0"
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator='.'
                  fullWidth
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto}
                  margin='dense'
                />
              </Grid>
              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <CurrencyTextField
                  disabled
                  label="Valor total"
                  helperText='Valor contabilizando valor unitário, quantidade e desconto nos disparos.'
                  variant="outlined"
                  currencySymbol="R$"
                  minimumValue="0"
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator='.'
                  fullWidth
                  margin='dense'
                  disabled
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal}
                />
              </Grid>

            </Grid>
          </ExpansionPanelDetails>

        </ExpansionPanel>
      </Grid>
    </Grid>
  );
}

ModalidadeDetalhes.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ModalidadeDetalhes;


